import { useEffect, useCallback } from 'react';

export function useNotifications() {
  useEffect(() => {
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission();
    }
  }, []);

  const notify = useCallback((title, body, onClick) => {
    if (!('Notification' in window) || Notification.permission !== 'granted') return;
    const n = new Notification(title, {
      body,
      icon: '/manifest.json', // substitua por ícone real quando disponível
      badge: '/manifest.json',
      tag: 'sallus-queue',    // agrupa notificações da fila (não empilha)
      renotify: true,
    });
    if (onClick) n.onclick = () => { window.focus(); onClick(); n.close(); };
  }, []);

  return { notify };
}
